import React from "react"
import styled from "styled-components"

const CardStyled = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  height: 10rem;

  img {
    object-fit: cover;
    max-width: 7rem;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;
    height: 20rem;
    flex: 0 0 25%;
    max-width: 25%;
    img {
      max-width: 14rem;
    }
  }
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  height: 5rem;
  * {
    padding: 0;
    margin: 0 0 0.5rem;
    font-size: 16px;
  }
  :first-of-type {
    margin-top: 0.8rem;
  }
  p {
    color: #999;
  }
`

const Card = ({ src, name, category, price }) => {
  return (
    <CardStyled>
      <img src={src} />

      <Details>
        <h2>{name}</h2>
        <p>{category}</p>
        <p>$ {price}</p>
      </Details>
    </CardStyled>
  )
}

export default Card
Card.defaultProps = {
  src: `https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80`,
  name: "Nike's Products",
  category: "Sport",
  price: 200,
}
